import React from 'react';
import { callToast, ToastContent } from '../shared/commons/Toast';

export function getToast(data = {}) {
    const {
        nTitle = '',
        nContent = '',
        nType = 'default',
        nDelay = 1000,
        nIcon = undefined,
        nDuration = 4500,
        nMobile = 1,
    } = data;
    let { nAlign = 'top-right' } = data;
    if (nTitle === '' || nContent === '') {
        console.log('nTitle and nContent required fields');
        return;
    }
    if (nMobile === 0 && window.innerWidth <= 420) {
        return;
    }
    switch (nAlign) {
        case 'topLeft':
            nAlign = 'top-left';
            break;
        case 'bottomRight':
            nAlign = 'bottom-right';
            break;
        case 'bottomLeft':
            nAlign = 'bottom-left';
            break;
        default:
            nAlign = 'top-right';
    }
    callToast(<ToastContent header={nTitle} text={nContent} icon={nIcon} />, {
        type: nType,
        delay: nDelay,
        position: nAlign,
        autoClose: nDuration,
    });
}
